import { render, staticRenderFns } from "./ScrollTo.vue?vue&type=template&id=759f5ad2&scoped=true&lang=pug"
import script from "./ScrollTo.vue?vue&type=script&lang=js"
export * from "./ScrollTo.vue?vue&type=script&lang=js"
import style0 from "./ScrollTo.vue?vue&type=style&index=0&id=759f5ad2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759f5ad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('759f5ad2')) {
      api.createRecord('759f5ad2', component.options)
    } else {
      api.reload('759f5ad2', component.options)
    }
    module.hot.accept("./ScrollTo.vue?vue&type=template&id=759f5ad2&scoped=true&lang=pug", function () {
      api.rerender('759f5ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/ScrollTo.vue"
export default component.exports